import { authHeader, handleResponse } from "./helper";
import { getCookie } from './cookies';
import config from "../config";

const getPatientData = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "branch_office_id": getCookie('branch_office_id'),
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiUrl}/patients/${params.patientId}/getData`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getPrestations = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    }
  };
  const url = new URL(
    `${config.apiUrl}/patients/${params.patientId}/getPrestations`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getPatientSurveys = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const url = new URL(`${config.apiUrl}/patients/getPatientSurvey`);

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  });

  return await fetch(url, requestOptions).then(handleResponse);
}

const savePatientSurvey = (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/patients/saveSurveyByPatient`);
  return fetch(url, requestOptions).then(handleResponse);
};

const getConsentings = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "branch_office_id": getCookie('branch_office_id'),
      ...authHeader(),
    }
  };
  const url = new URL(
    `${config.apiUrl}/patients/${params.patientId}/getConsentings`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const getAdmissions = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "branch_office_id": getCookie('branch_office_id'),
      ...authHeader(),
    }
  };
  const url = new URL(
    `${config.apiReservationUrl}/admissionPatients/${params.patientId}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const updatePatientData = (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/patients/${params.patientId}/update`);
  return fetch(url, requestOptions).then(handleResponse);
};

const getPatientByQuery = (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/patients/findPatients`);
  return fetch(url, requestOptions).then(handleResponse);
};

const getPatients = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    }
  };
  const url = new URL(
    `${config.apiUrl}/patients/listPatients?page=${params.page}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

const setAdmissionPatientExamState = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    }
  };
  const url = new URL(
    `${config.apiUrl}/patients/setAdmissionPatientExamState`
  );

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  });

  return await fetch(url, requestOptions).then(handleResponse);
}

const getExamsOfDay = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const url = new URL(`${config.apiUrl}/patients/getExamsOfDay`);

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  });

  return await fetch(url, requestOptions).then(handleResponse);
}

const generateReviewCode = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/patients/generateReviewCode`);
  return fetch(url, requestOptions).then(handleResponse);
}

const uploadConsent = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/consents/addExtraConsent`);
  return fetch(url, requestOptions).then(handleResponse);
}

export const patientsService = {
  getPatientData,
  getPrestations,
  getConsentings,
  getAdmissions,
  updatePatientData,
  getPatientByQuery,
  getPatients,
  getPatientSurveys,
  savePatientSurvey,
  setAdmissionPatientExamState,
  getExamsOfDay,
  generateReviewCode,
  uploadConsent,
};
